import React, { useState, useEffect } from "react";
import { Col, Row, Form, Button, message } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import UserEmail from "./account_email";
import UserPassword from "./account_password";
import { userSelector } from "../../../store/user/user.selector";
import { updateUserInfo } from "../../../store/user/user.action";
import { checkUpdateEmail } from "../../../store/auth/auth.action";

const wrapperCol = {
  xs: {
    span: 24,
    offset: 0,
  },
  sm: {
    span: 18,
    offset: 0,
  },
};

const labelCol = {
  xs: {
    span: 24,
    offset: 0,
  },
  sm: {
    span: 6,
    offset: 0,
  },
};

const resetData = (user, form) => {
  const values = {
    email: user?.email || "",
    password: "",
  };
  form.setFieldsValue(values);
};

const AccountFormEmail = () => {
  // -------------------------- VAR --------------------------
  const [form] = Form.useForm();
  const { t } = useTranslation("translation", { keyPrefix: "account" });
  // -------------------------- STATE --------------------------
  const [loading, setLoading] = useState(false);
  const [edit, setEdit] = useState(false);
  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  const user = useSelector(userSelector);
  // -------------------------- FUNCTION --------------------------

  const handleEdit = () => {
    resetData(user, form);
    setEdit(true);
  };

  const handleCancel = () => {
    resetData(user, form);
    setEdit(false);
  };

  // -------------------------- EFFECT --------------------------
  useEffect(() => {
    resetData(user, form);
  }, [user, form]);

  // -------------------------- DATA FUNCTION --------------------------

  const onFinish = (values) => {
    const { password, email } = values;
    setLoading(true);
    dispatch(
      checkUpdateEmail({ email, password }, (response) => {
        setLoading(false);
        if (response?.status === 200) {
          handleUpdateInfo({ email });
        }
        if (response?.status === 500) {
          message.error(response?.data || "Failed");
        }
      })
    );
  };

  const handleUpdateInfo = ({ email }) => {
    const update = { email };
    dispatch(
      updateUserInfo({ update }, (response) => {
        setLoading(false);
        if (response?.status === 200) {
          message.success("Update Email successfully!");
          setEdit(false);
        }
        if (response?.status === 500) {
          message.error(response?.data || "Failed");
        }
      })
    );
  };

  const onFinishFailed = (error) => {};

  // -------------------------- RENDER --------------------------

  const renderForm = () => {
    const disabled = loading || !edit;
    return (
      <Form
        labelCol={labelCol}
        wrapperCol={wrapperCol}
        name="email_form"
        autoComplete="off"
        form={form}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
      >
        <Row gutter={[16, 5]}>
          <Col xl={24} lg={24} md={24} xs={24}>
            <UserEmail disabled={disabled} />
          </Col>
          {renderPasswordField()}
          <Col xl={24} lg={24} md={24} xs={24}>
            {renderEditButton()}
            {renderSaveButton()}
          </Col>
        </Row>
      </Form>
    );
  };

  const renderPasswordField = () => {
    const disabled = loading;
    if (edit) {
      return (
        <Col xl={24} lg={24} md={24} xs={24}>
          <UserPassword disabled={disabled} />
        </Col>
      );
    }
  };

  const renderEditButton = () => {
    if (!edit) {
      return (
        <Row gutter={[16, 5]} justify="end" align="center">
          <Col>
            <Button
              type="primary"
              className="login-form-button form-button"
              loading={loading}
              onClick={() => handleEdit()}
            >
              {t("edit")}
            </Button>
          </Col>
        </Row>
      );
    }
    return null;
  };

  const renderSaveButton = () => {
    if (edit) {
      return (
        <Row gutter={[16, 0]} justify="end" align="center">
          <Col>
            <Button
              className="login-form-button form-button"
              disabled={loading}
              onClick={() => handleCancel()}
            >
              {t("cancel")}
            </Button>
          </Col>
          <Col>
            <Form.Item style={{ marginBottom: 0 }}>
              <Button
                type="primary"
                htmlType="submit"
                className="login-form-button form-button save"
                loading={loading}
              >
                {t("save")}
              </Button>
            </Form.Item>
          </Col>
        </Row>
      );
    }
    return null;
  };

  // -------------------------- MAIN --------------------------

  return (
    <Row gutter={[16, 5]}>
      <Col xl={24} lg={24} md={24} xs={24}>
        {renderForm()}
      </Col>
    </Row>
  );
};

export default AccountFormEmail;
